import { ActionButton } from '@adobe/react-spectrum';
import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import LinkOut from '@spectrum-icons/workflow/LinkOut';

export function BreadCrumbDeckLinkButton(props) {
    return (
        <ActionButton
            isDisabled={props?.isDisabled}
            aria-label="View deck"
            onPress={() => {
                const url = props.url?.replace(/\/\?cb\=.*/, '') || '';
                logEvent(getAnalytics(), 'preview_open_deck', { url });
                window.open(url, `_blank`);
            }}
        >
            <span className="bcBtnLabel">View deck</span>
            <LinkOut />
        </ActionButton>
    );
}
